<template>
	<div>
		<div class="title">
			<h2>{{ $t('instantFeedback') }}</h2>
		</div>

		<vx-card class="mt-5">
			<div v-if="user.hotel.hotel_id">
				<div v-if="feedback_sent == true">
					<p align="center">{{ $t('feedback_thanks') }}</p>
				</div>

				<div v-if="questions.length > 0 && feedback_sent == false">
					<div v-for="(question, question_index) in questions" :key="question_index" class="survey_element">
						<div class="mb-5">
							<h3>{{ !question[$i18n.locale] ? question[$i18n.locale == 'br' ? 'pt': 'en'] : question[$i18n.locale] }}</h3>
						</div>

						<ul class="centerx">
							<li v-for="(anwser, anwser_index) in question.anwsers" :key="anwser_index">
								<vs-radio color="#63C0BB" v-model="feedback[question_index].anwser_id" :vs-value="anwser.id">{{ !anwser[$i18n.locale] ? anwser[$i18n.locale == 'br' ? 'pt': 'en'] : anwser[$i18n.locale] }}</vs-radio>
							</li>
						</ul>
					</div>

					<div class="centerx mt-5">
						<vs-textarea size="large" :label="$t('feedback_comments')" v-model="comments" counter="3000" :counter-danger.sync="counterDanger" />
					</div>

					<div class="submit_button">
						<vs-button color="#63C0BB" size="large" type="filled" v-on:click="saveFeedback()">{{ $t('submit') }}</vs-button>
					</div>
				</div>
			</div>

			<div v-else>
				<p align="center">{{ $t('noFeedback') }}</p>
			</div>
		</vx-card>
	</div>
</template>

<script>
	export default {
	  data(){
		return {
		  radios1:'primary',
		  comments:'',
		  counterDanger: false,
		  questions: [],
		  feedback: [],
		  feedback_sent: false,
		  user: JSON.parse(localStorage.getItem('userSession'))
		  }
	  },

	  methods: {
		  getQuestions() {
			this.$vs.loading();
			let token = localStorage.getItem('usertoken');
			let self = this;

			this.$api({
				method: 'get',
				url: '/myvilagale/feedback/questions',
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				self.questions = res.data;
				for (let i = 0; i < self.questions.length; i++) {
					self.feedback.push({
						question_id: self.questions[i].id,
						anwser_id: ''
					})
				}
				self.$vs.loading.close();
			})
			.catch((err) => {
				self.$vs.loading.close();
			});
		},

		saveFeedback() {
			let feedback_error = false
			this.feedback.forEach(anwser => {
				if (!anwser.anwser_id) {
					feedback_error = true;					
				}
			});

			if (feedback_error) {
				this.$vs.notify({
					text: this.$t('empty_feedback'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				return false;
			}

			if (this.counterDanger) {
				this.$vs.notify({
                    text: this.$t('long_comment_feedback'),
                    color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				return false;
			}

			this.$vs.loading();
			let token = localStorage.getItem('usertoken');
			let user = JSON.parse(localStorage.getItem('userSession'))
			let self = this;
			let data = {
				client_id: user.id,
				hotel_id: user.hotel.hotel_id,
				reservation_id: user.hotel.num_reserva,
				anwsers: this.feedback,
				comments: this.comments
			}

			this.$api.post( '/myvilagale/feedback?token=' + localStorage.getItem('usertoken'),
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                }
            })
			.then((res) => {
				self.$vs.loading.close();
				self.feedback_sent = true;
			})
			.catch((err) => {
				self.$vs.loading.close();
			});
		}
	},

	created() {
		this.getQuestions();
	}
}	
</script>

<style>
	.submit_button {
		text-align: center;
	}
	.survey_element {
		margin-bottom: 45px;
	}
</style>
